export enum AppGuardType {
    AUTHENTICATED_BY_OKTA_THEN_LOGGEDIN = 'AUTHENTICATED_BY_OKTA_THEN_LOGGEDIN', // User has been authenticated, then logged in
    AUTHENTICATED_BY_CUSTOM_OKTA_THEN_LOGGEDIN = 'AUTHENTICATED_BY_CUSTOM_OKTA_THEN_LOGGEDIN', // User has been authenticated, then logged in
    NOT_AUTHENTICATED_JUST_LOGGEDIN = 'NOT_AUTHENTICATED_JUST_LOGGEDIN'
}
